import React from "react";
import moment from "moment";
import { DatePicker, TimePicker } from "antd";

export default function DatePickerWithHours({
  label,
  value,
  onChange,
  value2,
  onChange2,
  error,
}) {
  const disabledHoursOpt = [0, 1, 2, 3, 4, 5, 6, 7, 21, 22, 23];

  function disabledDate(current) {
    return current < moment().subtract(1, "days") || moment(current).day() === 0 
  }

  function disabledDateTime() {
    return {
      disabledHours: () => disabledHoursOpt,
    };
  }

  const firstHours = value
    ? [...new Array(+moment(value).format("HH"))].map((_, idx) => idx + 1)
    : [];

  return (
    <div className="form-group py-2">
      <div className="d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ width: "50%" }}>
          <label className="editLabelForm">From</label>
          <DatePicker
            disabledDate={disabledDate}
            disabledTime={disabledDateTime}
            format="YYYY-MM-DD HH:mm"
            placeholder="YYYY-MM-DD HH:mm"
            value={value}
            showTime={{ defaultValue: moment("00:00:00", "HH:mm") }}
            onChange={onChange}
            showNow={false}
            hideDisabledOptions={true}
          />
        </div>
        <div className="d-flex flex-column" style={{ width: "50%" }}>
          <label className="editLabelForm">To</label>
          <TimePicker
            placeholder="HH:mm"
            value={value2}
            showTime={{ defaultValue: moment("00:00", "HH:mm") }}
            hideDisabledOptions={true}
            onChange={onChange2}
            showNow={false}
            disabledHours={() => [
              ...new Set([...disabledHoursOpt, ...firstHours]),
            ]}
            format={"HH:mm"}
          />
        </div>
      </div>
      {error && <div className="text-danger small">{error}</div>}
    </div>
  );
}
